import { type CloudFlareResult, type ProcessFileType, clientConfig } from "@quickpoint.me/shared";

import { nanoid } from "nanoid";



export async function uploadImageToCloudflare({ imageFile, validCloudFlareUploadUrl, jwt }: { imageFile: ProcessFileType, validCloudFlareUploadUrl: string | false, jwt: string }): Promise<CloudFlareResult> {
    const randomFileName = nanoid(26);
    const formData: FormData = new FormData();
    formData.set("file", imageFile.data, randomFileName);

    let uploadUrl = "";
    if (!validCloudFlareUploadUrl) {
        const cloudFlareResult = await fetch(clientConfig.uploadImageUrl(jwt));
        if (cloudFlareResult.status === 402) {
            // tier storage cap — surfaced with a specific message upstream
            throw new Error("storage-limit");
        }
        if (!cloudFlareResult.ok) {
            throw new Error("Failed to get Cloudflare upload URL");
        }
        uploadUrl = await cloudFlareResult.text();
    } else {
        uploadUrl = validCloudFlareUploadUrl;
    }

    try {
        const resStream: Response = await fetch(uploadUrl, {
            method: "POST",
            body: formData,
        });
        if (!resStream.ok) {
            throw new Error("Failed to upload image to Cloudflare");
        }
        const decoded = await resStream.json() as CloudFlareResult;
        decoded.url = uploadUrl;
        if (!decoded.success) {
            throw new Error("Upload Image To Cloudflare Failed");
        }
        return decoded;
    } catch (e) {
        throw new Error(`Upload Image To Cloudflare Error: ${e instanceof Error ? e.message : String(e)}`);
    }
}

